<template>
  <div class="page-container-content tabgroup">
    <w-flow-analysis-view ref="flowAnalysisView" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import WFlowAnalysisView from './components/view/FlowAnalysisView';

export default {
  name: 'WFlowAnalysis',
  components: {
    WFlowAnalysisView,
  },
  data() {
    return {
      activeTab: 'flowAnalysis',
      mountedFlag: false,
    };
  },
  props: {
    active: {
      type: Boolean,
    },
  },
  computed: mapGetters(['analysisDateParams', 'selectedNode']),
  watch: {
    /**
     * 첫 로드시에는 관리대상 리스트까지 로드, 그 이후 기간필터 변경시에는 차트만 재로드.
     * @return {Boolean} [description]
     * @author jda
     */
    analysisDateParams() {
      if (this.mountedFlag) {
        this.$refs.flowAnalysisView.loadFlowChart();
      } else {
        this.$refs.flowAnalysisView.setBasicFilter(true);
        this.mountedFlag = true;
      }
    },
    selectedNode(to) {
      if (to.type === 'root') {
        this.$refs.flowAnalysisView.setBasicFilter(true);
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/FlowAnalysis/index.vue